import React, { useRef, useState } from 'react'

import { Modal, Row, Col, FormControl, FormLabel, Form } from 'react-bootstrap'
import Button from 'react-bootstrap-button-loader'
import * as ajax from '../Utilities/ajax'
import Select from 'react-select'
import { Tooltip, IconButton } from '@material-ui/core'
import { BsPencil } from 'react-icons/bs'
import DatePicker from "react-datepicker"

export default function NewVideo(props) {
  const MAX_FILE_SIZE_GB = 2

  const [state, setState] = useState({
    loading: false,
    video: {
      title: undefined,
      file_name: undefined,
      description: undefined,
      tag: [],
      section: undefined,
      fileImg: undefined,
    }
  })

  const [isDisable, setDisable] = useState(false)
  const [file, setFile] = useState('')
  const [filename, setFileName] = useState(undefined)
  const [fileImage, setFileNameImage] = useState(null)
  const [_Date, setNewDate] = useState(new Date())

  const handleFile = (fileInfo) => {
    const selectedFile = fileInfo?.file

    if (!selectedFile) return

    if (selectedFile.size > MAX_FILE_SIZE_GB * 1024 * 1024 * 1024) {
      alert(`File size exceeds ${MAX_FILE_SIZE_GB} GB limit`)
      if (ref.current) ref.current.value = ""
      return
    }

    setFile(selectedFile)

    let video = state.video
    video.title = selectedFile.name.slice(0, -4)
    video.file_name = selectedFile.name

    setState({ ...state, video })
    setFileName(selectedFile.name)
  }

  const ref = useRef<HTMLInputElement>(null)
  const refImg = useRef<HTMLInputElement>(null)

  const onModalConfirm = async () => {
    setState({ ...state, loading: true })
    let _files = []
    _files.push(file)
    if (state.video.fileImg) _files.push(state.video.fileImg)
    const files = new FormData()
    for (let i = 0; i < _files.length; i++) {
      files.append(`sampleFile[${i}]`, _files[i], filename)
    }

    const tags = JSON.stringify(state.video.tag)
    const result = await ajax.postFormData(`/video/create?file_name=${state.video.file_name}&title=${state.video.title}&description=${state.video.description}&is_disabled=${isDisable}&tag=${tags}&section=${state.video.section}&newVideoOutOfTime=${_Date}&fileImage=${fileImage}`, files)
    setState({
      ...state, loading: false, video: {
        title: undefined,
        file_name: undefined,
        description: undefined,
        tag: [],
        section: undefined,
        fileImg: '',
      }
    })
    setFile('')
    setDisable(false)
    setFileName(undefined)
    setFileNameImage(undefined)
    setNewDate(new Date())
    props.callback(result)
  }

  const handleForm = (event) => {
    let video = state.video
    video[event.target.name] = event.target.value
    setState({ ...state, video })
  }
  const handleFormSelect = (e, key) => {
    let video = state.video
    video[key] = e.value
    setState({ ...state, video })
  }

  const handleTags = (value, { action, removedValue }) => {
    let video = state.video
    switch (action) {
      case 'remove-value':
        video.tag = value.map(v => v.tagname)
        setState({ ...state, video })
        break;
      case 'select-option':
        video.tag = value.map(v => v.tagname)
        setState({ ...state, video })
        break;
      case 'clear':
        video.tag = []
        setState({ ...state, video })
        break;
    }
  }

  const setFrom = (e: any) => {
    setNewDate(e)
  }

  const handleChange = (event) => {
    const img = event.target.files[0]

    if (!img) return

    if (img.size > MAX_FILE_SIZE_GB * 1024 * 1024 * 1024) {
      alert(`File size exceeds ${MAX_FILE_SIZE_GB} GB limit`)
      if (refImg.current) refImg.current.value = ""
      return
    }

    const { video } = state
    video.fileImg = img

    setFileNameImage(img.name)
    setState({ ...state, video })
  }

  const tags = props.tags
  const sections = props.sections

  return (
    <Modal show={props.open.show}>
      <Modal.Header>
        <Modal.Title>Create New Video</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.File id="formcheck-api-custom" custom style={{ display: "none" }} >
          <Form.File.Input isValid={true} ref={ref} accept="video/*" onChange={e => handleFile({ file: e.target.files[0] })} />
          <Form.File.Input isValid={true} ref={refImg} accept="image/*" onChange={handleChange} />
        </Form.File>
        <Row>
          <Col xs={5} sm={4}><FormLabel style={{ marginTop: '6px' }}>Video</FormLabel></Col>
          <Col xs={5} sm={7} style={{ display: "flex", alignItems: "flex-end" }} >
            <Button variant="outline-secondary"
              style={{ marginTop: '5px' }}
              onClick={() => ref.current.click()}
              disabled={state.loading}>
              Browse
            </Button>
            {filename && <span style={{ marginLeft: '5px' }} >{filename}</span>}
          </Col>
        </Row>
        {filename && <Row>
          <Col xs={5} sm={4}><FormLabel style={{ marginTop: '6px' }}>Thumbnail</FormLabel></Col>
          <Col xs={5} sm={7} style={{ display: "flex", alignItems: "flex-end" }} >
            <Button variant="outline-secondary"
              style={{ marginTop: '5px' }}
              onClick={() => refImg.current.click()}
              disabled={state.loading}>
              Browse
            </Button>
            {fileImage && <span style={{ marginLeft: '5px' }} >{fileImage}</span>}
          </Col>
        </Row>}
        <img src="" alt="" />
        {filename && <Row>
          <Col xs={5} sm={4}><FormLabel style={{ marginTop: '6px' }}>Title</FormLabel></Col>
          <Col xs={5} sm={7}>
            <FormControl type="text" name="title" style={{ marginTop: '5px' }} value={state.video.title || ""} onChange={handleForm} />
          </Col>
        </Row>}
        {filename && <Row>
          <Col xs={5} sm={4}><FormLabel style={{ marginTop: '6px' }}>Description</FormLabel></Col>
          <Col xs={5} sm={7}>
            <FormControl type="text" as="textarea" rows={3} name="description" placeholder="description" style={{ marginTop: '5px' }} value={state.video.description || ""} onChange={handleForm} />
          </Col>
        </Row>}
        {filename && <Row>
          <Col xs={5} sm={4}>
            <FormLabel style={{ marginTop: '6px' }}>
              Section
              <Tooltip title="Edit Section" aria-label="add">
                <IconButton aria-label="delete" style={{ marginLeft: "3px" }} onClick={() => props.handleData("Section", "new")}>
                  <BsPencil style={{ color: "blue" }} />
                </IconButton>
              </Tooltip>
            </FormLabel>
          </Col>
          <Col xs={5} sm={7} style={{ marginTop: '6px' }} >
            <Select
              className="basic-single"
              classNamePrefix="select"
              onChange={e => handleFormSelect(e, "section")}
              isClearable
              isSearchable
              name="section"
              options={sections}
            />
          </Col>
        </Row>}
        {filename && <Row>
          <Col xs={5} sm={4}>
            <FormLabel style={{ marginTop: '6px' }}>
              Tag
              <Tooltip title="Edit Tag" aria-label="add">
                <IconButton aria-label="delete" onClick={() => props.handleData("Tag", "new")} style={{ marginLeft: "3px" }} >
                  <BsPencil style={{ color: "blue" }} />
                </IconButton>
              </Tooltip>
            </FormLabel>
          </Col>
          <Col xs={5} sm={7} style={{ marginTop: '6px' }} >
            <Select
              className="basic-single"
              classNamePrefix="select"
              isMulti
              onChange={handleTags}
              isClearable
              isSearchable
              name="tag"
              options={tags}
            />
          </Col>
        </Row>}
        {filename && <Row>
          <Col xs={5} sm={4}><FormLabel style={{ marginTop: '6px' }}>Show Video</FormLabel></Col>
          <Col xs={5} sm={7} style={{ marginTop: '6px' }} >
            <Form.Check
              id={`default-switch`}
              onClick={() => setDisable(!isDisable)}
              defaultChecked={!isDisable}
            />
          </Col>
        </Row>}
        {filename && <Row>
          <Col xs={5} sm={4}><FormLabel style={{ marginTop: '6px' }}>New Video Day</FormLabel></Col>
          <Col xs={5} sm={7} style={{ marginTop: '6px' }} >
            <DatePicker minDate={new Date()} selected={_Date} dateFormat="dd/MM/yyyy" onChange={date => setFrom(date)} />
          </Col>
        </Row>}
      </Modal.Body>
      <Modal.Footer>
        <Button bsStyle="primary"
          loading={state.loading}
          onClick={onModalConfirm}
          disabled={
            ((state.video.title || "").length === 0 || (state.video.file_name || "").length === 0)
          }>
          {state.loading ? 'Please wait' : 'Upload'}
        </Button>
        <Button bsStyle="default" onClick={() => props.callback()}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  )
}
